/**
 * Vuex "siwfauth" module (registered as `siwf` in the root store).
 *
 * Holds "Sign In With Farcaster" (SIWF) data for the current session: state
 * (store.js), actions (operations.js), getters (selectors.js), and mutations
 * (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
